var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type-hangul"},[_c('div',{ref:"type",staticClass:"paper"},[_vm._v(_vm._s(_vm.textData))]),(_vm.cursor)?_c('span',{staticClass:"cursor",class:{typing: _vm.typing}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }